import React from "react"
import styled, { css } from "styled-components"
import { Settings } from "../../../styles/theme"

const oneStyle = `
  > div {
    flex: 1 1 100%;
  }
`

const twoStyle = `
  > div {
    flex: 1 1 48%;
    @media screen and (max-width: ${Settings.sizeM}) {
      flex: 1 1 100%;
    }
  }
`

const threeStyle = `
  > div {
    flex: 1 1 32%;
    @media screen and (max-width: ${Settings.sizeM}) {
      flex: 1 1 100%;
    }
  }
`

const threeHalfStyle = `
  > div {
    flex: 1 1 32%;
    @media screen and (max-width: ${Settings.sizeM}) {
      flex: 1 1 50%;
    }
  }
`

const fourStyle = `
  > div {
    flex: 1 1 24%;
    @media screen and (min-width: ${Settings.sizeM}) and (max-width: ${Settings.sizeL}) {
      flex: 1 1 48%;
    }
    @media screen and (max-width: ${Settings.sizeM}) {
      flex: 1 1 100%;
    }
  }
`

const fiveStyle = `
  justify-content: center;
  > div {
    flex: 1 1 19%;
    @media screen and (min-width: ${Settings.sizeM}) and (max-width: ${Settings.sizeL}) {
      flex: 1 1 48%;
    }
    @media screen and (max-width: ${Settings.sizeM}) {
      flex: 1 1 100%;
    }
  }
`

const Gridstyle = styled.div`
  position: relative;
  display: flex;
  flex-wrap: ${props => (props.unstack ? "nowrap" : "wrap")};
  align-items: center;
  justify-content: space-between;
  .three-resp {
    @media screen and (max-width: ${Settings.sizeM}) {
      flex: 1 1 32% !important;
    }
  }
  .two-resp {
    @media screen and (max-width: ${Settings.sizeM}) {
      flex: 1 1 48% !important;
    }
  }
  .one-resp {
    @media screen and (max-width: ${Settings.sizeM}) {
      flex: 1 1 100% !important;
    }
  }

  ${props =>
    props.columns === 4
      ? css`
          ${fourStyle}
        `
      : props.columns === 2
      ? css`
          ${twoStyle}
        `
      : props.columns === 1
      ? css`
          ${oneStyle}
        `
      : props.columns === 5
      ? css`
          ${fiveStyle}
        `
      : props.half === true
      ? css`
          ${threeHalfStyle}
        `
      : css`
          ${threeStyle}
        `}
`

export const Grid = ({ children, columns, unstack, half, nostretch }) => (
  <Gridstyle
    columns={columns}
    unstack={unstack}
    half={half}
    nostretch={nostretch}
  >
    {children}
  </Gridstyle>
)
